import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import interact from "interactjs";

// Connects to data-controller="modal-page"
export default class extends Controller {

  connect() {
    // // ブラウザ上のURL書き換え
    // const turboPath = this.element.dataset.turboPath
    const self = this;
    // if (turboPath?.length > 0) {
    //   const currentPath = location.href
    //   history.pushState(null, null, turboPath)
    //   this.element.addEventListener('hidden.bs.modal', function (event) {
    //     history.replaceState(null, null, currentPath)
    //     self.disconnect();
    //   })
    // } else {
    //   this.element.addEventListener('hidden.bs.modal', function (event) {
    //     self.disconnect();
    //   })
    // }
    // // リサイズ
    // if (this.element.dataset.resize) {
    //   this.element.addEventListener('shown.bs.modal', function (event) {
    //     interact('.resize-modal')
    //       .resizable({
    //         edges: { left: true, right: false, bottom: false, top: false },
    //         listeners: {
    //           move (event) {
    //             event.target.setAttribute('style', `max-width: ${event.rect.width}px !important;`)
    //           }
    //         },
    //         modifiers: [
    //           interact.modifiers.restrictSize({
    //             min: { width: 500 },
    //           }),
    //         ]
    //       })
    //   })
    // }
    // // すでにmodalが表示されていたら、除去する
    // const backdrop = document.querySelector('.modal-backdrop')
    // backdrop?.remove()
    // モーダルの表示
    this.remoteModal = new Modal(this.element)
    this.remoteModal.show()
    this.element.addEventListener('hidden.bs.modal', function (event) {
      self.disconnect();
    })
  }

  remove(event) {
    if (confirm('削除しますか？')) {
      this.disconnect();
    } else {
      event.preventDefault();
    }
  }

  dismiss(event) {
    event.preventDefault();
    this.disconnect();
  }

  disconnect() {
    if (this.remoteModal) {
      this.remoteModal.hide()
    }
    const backdrop = document.querySelector('.modal-backdrop')
    backdrop?.remove()
    this.element.remove();
  }
}
